<script>
  import conciliacaoProjetoServico from '../servico';

  const TIPOS = {
    CONC_CONCILIAR: { rotulo: 'Conciliação', cls: 'ok', icon: 'fa-check' },
    CONC_AUTOMATICA: { rotulo: 'Conciliação automática', cls: 'auto', icon: 'fa-bolt' },
    CONC_DESFAZER: { rotulo: 'Conciliação desfeita', cls: 'erro', icon: 'fa-undo' },
    CONC_PAR_PERDIDO: { rotulo: 'Desfeita por alteração fora do módulo', cls: 'erro', icon: 'fa-chain-broken' },
    CONC_TRANSITORIA: { rotulo: 'Transitória', cls: 'op', icon: 'fa-exchange' },
    CONC_TRANSIT_AUTO: { rotulo: 'Transitória automática', cls: 'auto', icon: 'fa-exchange' },
    CONC_CRED_IDENTIF: { rotulo: 'Crédito a identificar', cls: 'op', icon: 'fa-question-circle' },
    CONC_CONTA_RECEBER: { rotulo: 'Contas a receber', cls: 'op', icon: 'fa-download' },
    CONC_CREDITO_DIRETO: { rotulo: 'Crédito direto', cls: 'op', icon: 'fa-plus-circle' },
    CONC_DEBITO_DIRETO: { rotulo: 'Débito direto', cls: 'op', icon: 'fa-minus-circle' },
    CONC_TRANSFERENCIA: { rotulo: 'Transferência', cls: 'op', icon: 'fa-random' },
    CONC_SOLIC_TRANSF: { rotulo: 'Solicitação de transferência', cls: 'op', icon: 'fa-random' },
    CONC_TRANSF_SALDO: { rotulo: 'Transferência de saldo', cls: 'op', icon: 'fa-random' },
    CONC_SOLIC_SALDO: { rotulo: 'Solicitação de saldo', cls: 'op', icon: 'fa-random' },
    CONC_APLICACAO: { rotulo: 'Aplicação', cls: 'op', icon: 'fa-line-chart' },
    CONC_RESGATE: { rotulo: 'Resgate', cls: 'op', icon: 'fa-line-chart' },
    CONC_AUTOMACAO_APLIC: { rotulo: 'Aplicação automática', cls: 'auto', icon: 'fa-line-chart' },
    CONC_AJUSTE_DIF: { rotulo: 'Ajuste de diferença', cls: 'op', icon: 'fa-sliders' },
    CONC_TARIFA_BORDERO: { rotulo: 'Tarifa de borderô', cls: 'op', icon: 'fa-money' },
  };

  const MOTIVOS_FORA = [
    { trecho: 'lançamento apagado fora do módulo', rotulo: 'Lançamento apagado fora do módulo', icon: 'fa-trash' },
    { trecho: 'lançamento movido para outra conta', rotulo: 'Lançamento movido para outra conta fora do módulo', icon: 'fa-share' },
    { trecho: 'lançamento desconciliado fora do módulo', rotulo: 'Desconciliado fora do módulo', icon: 'fa-chain-broken' },
    { trecho: 'valor do lançamento alterado fora do módulo', rotulo: 'Valor alterado fora do módulo', icon: 'fa-pencil' },
  ];

  export default {
    props: {
      idContaCript: { type: String, required: true },
      nomeConta: { type: String, default: '' },
      grupo: { type: Number, default: 0 },
      lancamentos: { type: Array, default: () => [] },
      extratos: { type: Array, default: () => [] },
    },
    data() {
      return { carregando: true, erro: '', dados: null, busca: '' };
    },
    computed: {
      registros() { return (this.dados && this.dados.registros) || []; },
      filtrados() {
        const termo = (this.busca || '').trim().toLowerCase();
        if (!termo) return this.registros;
        return this.registros.filter(r => [r.dataHora, r.usuario, r.informacao, this.tipo(r).rotulo, r.lancamentos, r.extratos, String(r.idGrupo)]
          .some(v => (v || '').toString().toLowerCase().indexOf(termo) >= 0));
      },
      porDia() {
        const dias = [];
        this.filtrados.forEach(r => {
          const dia = (r.dataHora || '').substr(0, 10);
          let bloco = dias[dias.length - 1];
          if (!bloco || bloco.dia !== dia) { bloco = { dia, itens: [] }; dias.push(bloco); }
          bloco.itens.push(r);
        });
        return dias;
      },
      escopo() {
        const partes = [];
        if (this.grupo > 0) partes.push('grupo ' + this.grupo);
        const ql = this.dados ? this.dados.qtdeLancamentos : this.lancamentos.length;
        const qe = this.dados ? this.dados.qtdeExtratos : this.extratos.length;
        if (ql) partes.push(ql + (ql > 1 ? ' lançamentos' : ' lançamento'));
        if (qe) partes.push(qe + (qe > 1 ? ' linhas do extrato' : ' linha do extrato'));
        return partes.join(' · ');
      },
    },
    created() { this.carregar(); },
    methods: {
      carregar() {
        this.carregando = true; this.erro = '';
        conciliacaoProjetoServico.logConciliacaoBanco(this.idContaCript, {
          grupo: this.grupo || 0,
          lancamentos: this.lancamentos,
          extratos: this.extratos,
        })
          .then(d => { this.dados = d; this.carregando = false; })
          .catch(e => {
            this.carregando = false;
            this.erro = (e && e.body && e.body.message) || 'Não foi possível carregar o log.';
          });
      },
      tipo(r) {
        const base = TIPOS[r.tipoLog] || { rotulo: r.tipoLog || 'Registro', cls: 'op', icon: 'fa-circle-o' };
        if (r.tipoLog !== 'CONC_PAR_PERDIDO') return base;
        const motivo = MOTIVOS_FORA.find(m => (r.informacao || '').indexOf(m.trecho) >= 0);
        return motivo ? Object.assign({}, base, { rotulo: motivo.rotulo, icon: motivo.icon, motivo: motivo.trecho }) : base;
      },
      hora(r) { return (r.dataHora || '').substr(11, 8); },
      detalhes(r) {
        const repetidos = ['Conciliação manual', 'Desfazer conciliação', 'Conciliação com justificativa', 'Conciliação pago em outra conta', 'Par do Web perdido'];
        const motivo = this.tipo(r).motivo;
        return (r.informacao || '').split(' · ').map(p => p.trim())
          .filter((p, i) => p
            && !/^usuário \d+$/.test(p) && !/^conta \d+$/.test(p)
            && !(r.idGrupo && p === 'grupo ' + r.idGrupo)
            && !(i === 0 && (p === r.tipoLog || repetidos.indexOf(p) >= 0))
            && !(motivo && p.indexOf(motivo) === 0));
      },
    },
  };
</script>

<template>
  <div class="lgc-ov">
    <div class="lgc-modal" role="dialog" aria-modal="true" aria-label="Log da conciliação">
      <div class="lgc-head">
        <div class="lgc-head-ic"><i class="fa fa-history"></i></div>
        <div class="lgc-head-txt">
          <h4>Log da conciliação</h4>
          <small>{{ nomeConta }}<template v-if="escopo"> · {{ escopo }}</template></small>
        </div>
        <div v-if="dados && registros.length" class="lgc-head-resumo">
          <b>{{ registros.length }}</b> registro{{ registros.length > 1 ? 's' : '' }}
        </div>
      </div>

      <div v-if="dados && registros.length" class="lgc-barra">
        <div class="lgc-busca">
          <i class="fa fa-search"></i>
          <input v-model="busca" type="text" placeholder="Filtrar por usuário, lançamento, extrato, texto…">
        </div>
      </div>

      <div class="lgc-corpo">
        <div v-if="carregando" class="lgc-msg"><i class="fa fa-spinner fa-pulse"></i> Carregando log…</div>
        <div v-else-if="erro" class="lgc-msg lgc-msg-erro"><i class="fa fa-exclamation-triangle"></i> {{ erro }}</div>
        <div v-else-if="dados && !dados.tabelaDisponivel" class="lgc-vazio">
          <i class="fa fa-database"></i>
          <b>Log da conciliação ainda não instalado</b>
          <span>Rode a atualização do banco (TBLogConciliacaoWeb e TBLogConciliacaoWebItem).</span>
        </div>
        <div v-else-if="!registros.length" class="lgc-vazio">
          <i class="fa fa-history"></i>
          <b>Nenhum registro</b>
          <span>Só aparecem as ações gravadas pelo log novo da conciliação Web.</span>
        </div>
        <div v-else-if="!filtrados.length" class="lgc-vazio">
          <i class="fa fa-filter"></i>
          <b>Nada com esse filtro</b>
        </div>
        <template v-else>
          <div v-for="bloco in porDia" :key="bloco.dia" class="lgc-grupo">
            <div class="lgc-dia"><span>{{ bloco.dia }}</span></div>
            <div v-for="r in bloco.itens" :key="r.idLog" class="lgc-item" :class="'lgc-' + tipo(r).cls">
              <div class="lgc-hora mono">{{ hora(r) }}</div>
              <div class="lgc-ic"><i class="fa" :class="tipo(r).icon"></i></div>
              <div class="lgc-txt">
                <div class="lgc-tit">
                  <b>{{ tipo(r).rotulo }}</b>
                  <span v-if="r.idGrupo" class="lgc-tag mono">grupo {{ r.idGrupo }}</span>
                  <span class="lgc-usu"><i class="fa fa-user"></i> {{ r.usuario || 'sem usuário' }}</span>
                </div>
                <div class="lgc-det">
                  <span v-for="(p, i) in detalhes(r)" :key="i">{{ p }}</span>
                </div>
                <div v-if="r.lancamentos || r.extratos" class="lgc-ids mono">
                  <span v-if="r.lancamentos">Lançamentos: {{ r.lancamentos }}</span>
                  <span v-if="r.extratos">Extrato: {{ r.extratos }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div class="lgc-foot">
        <div class="lgc-foot-info">
          <template v-if="dados && dados.truncado">Mostrando os 500 registros mais recentes</template>
          <template v-else-if="dados && registros.length">Mostrando {{ filtrados.length }} de {{ registros.length }}</template>
        </div>
        <button type="button" class="lgc-sair" @click="$emit('fechar')"><i class="fa fa-sign-out"></i> Sair</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .lgc-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.45); z-index: 2100; display: flex; align-items: center; justify-content: center; padding: 16px; }
  .lgc-modal { width: 900px; max-width: 97vw; max-height: 90vh; display: flex; flex-direction: column; background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28); overflow: hidden; }
  .lgc-head { flex: 0 0 auto; display: flex; align-items: center; gap: 14px; padding: 15px 20px; background: #f7f9fa; border-bottom: 1px solid #e6e9ed; color: #1c2024; }
  .lgc-head-ic { flex: none; width: 38px; height: 38px; border-radius: 8px; background: #e8f0fa; color: #2b6cb0; display: flex; align-items: center; justify-content: center; font-size: 18px; }
  .lgc-head-txt { flex: 1 1 auto; min-width: 0; }
  .lgc-head-txt h4 { margin: 0; font-size: 16px; font-weight: 600; color: #1c2024; }
  .lgc-head-txt small { display: block; margin-top: 2px; font-size: 12px; color: #6b747e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .lgc-head-resumo { flex: none; font-size: 13px; color: #4b545e; }
  .lgc-head-resumo b { font-size: 18px; color: #1c2024; }

  .lgc-barra { flex: 0 0 auto; display: flex; gap: 10px; align-items: center; padding: 12px 20px; border-bottom: 1px solid #e6eaee; }
  .lgc-busca { flex: 1 1 auto; position: relative; }
  .lgc-busca .fa { position: absolute; left: 10px; top: 9px; color: #9aa3ac; font-size: 13px; }
  .lgc-busca input { width: 100%; height: 32px; padding: 0 10px 0 30px; border: 1px solid #d3d8de; border-radius: 7px; font-size: 12.5px; outline: none; }
  .lgc-busca input:focus { border-color: #2b6cb0; box-shadow: 0 0 0 2px rgba(43,108,176,.15); }

  .lgc-corpo { flex: 1 1 auto; min-height: 220px; overflow: auto; padding: 6px 20px 16px; }
  .lgc-msg { padding: 40px 10px; text-align: center; color: #8a939c; font-size: 13px; }
  .lgc-msg-erro { color: #a13c3c; }
  .lgc-vazio { display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 44px 16px; text-align: center; color: #6b747e; font-size: 12.5px; }
  .lgc-vazio > .fa { font-size: 30px; color: #b9c8da; }
  .lgc-vazio > b { font-size: 14px; color: #3b444d; }

  .lgc-dia { position: sticky; top: 0; z-index: 1; padding: 12px 0 6px; background: #fff; }
  .lgc-dia span { display: inline-block; font-size: 11px; font-weight: 700; letter-spacing: .05em; color: #2b6cb0; background: #e8f0fa; border-radius: 10px; padding: 3px 10px; }
  .lgc-item { display: flex; align-items: flex-start; gap: 12px; padding: 10px 12px; margin-bottom: 7px; border: 1px solid #e3e8ee; border-left: 3px solid #8a9bb0; border-radius: 7px; background: #fff; }
  .lgc-hora { flex: none; width: 62px; padding-top: 2px; font-size: 12px; color: #6b747e; }
  .lgc-ic { flex: none; width: 26px; height: 26px; border-radius: 6px; display: flex; align-items: center; justify-content: center; font-size: 13px; background: #eef1f4; color: #5b6570; }
  .lgc-txt { flex: 1 1 auto; min-width: 0; }
  .lgc-tit { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; font-size: 13px; color: #1c2024; }
  .lgc-tag { font-size: 11px; padding: 1px 7px; border-radius: 9px; background: #eef1f4; color: #4b545e; }
  .lgc-usu { margin-left: auto; font-size: 12px; color: #4b545e; }
  .lgc-usu .fa { color: #9aa3ac; margin-right: 3px; }
  .lgc-det { margin-top: 4px; display: flex; flex-wrap: wrap; gap: 4px 12px; font-size: 12px; color: #4b545e; }
  .lgc-det span { word-break: break-word; }
  .lgc-ids { margin-top: 5px; display: flex; flex-wrap: wrap; gap: 4px 14px; font-size: 11.5px; color: #8a939c; }

  .lgc-ok { border-left-color: #0f8a5f; }
  .lgc-ok .lgc-ic { background: #e8f5ef; color: #0a6d4d; }
  .lgc-auto { border-left-color: #2b6cb0; }
  .lgc-auto .lgc-ic { background: #e8f0fa; color: #2b6cb0; }
  .lgc-erro.lgc-item { border-left-color: #c0392b; background: #fffafa; }
  .lgc-erro .lgc-ic { background: #fbe6e6; color: #a13c3c; }
  .lgc-op { border-left-color: #d69e2e; }
  .lgc-op .lgc-ic { background: #fdf5e6; color: #8a5a00; }

  .lgc-foot { flex: 0 0 auto; display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 12px 20px; border-top: 1px solid #e6eaee; }
  .lgc-foot-info { font-size: 12px; color: #6b747e; }
  .lgc-sair { display: inline-flex; align-items: center; gap: 7px; background: #fdf1f1; border: 1px solid #e4d7d7; border-radius: 5px; padding: 8px 18px; font-size: 12.5px; color: #a13c3c; font-weight: 600; }
  .lgc-sair:hover { background: #fbe6e6; }
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; }

  @media (max-width: 640px) {
    .lgc-item { flex-wrap: wrap; }
    .lgc-usu { margin-left: 0; }
    .lgc-head-resumo { display: none; }
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/LogConciliacaoModal.vue